/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from '../../index-892d8eee.js';
import { extend } from '../extend/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var getScrollOffset$6 = function getScrollOffset(selector) {
  return new Promise(function (resolve) {
    my.createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
      resolve(ret[0] ? ret[0].map(function (i) {
        return {
          scrollLeft: i.scrollLeft,
          scrollTop: i.scrollTop
        };
      }) : []);
    });
  });
};

var styleBoundingClientRectResponse = function styleBoundingClientRectResponse(data) {
  return data ? data.map(function (res) {
    return {
      left: isNone(res.left) ? '' : res.left,
      right: isNone(res.right) ? '' : res.right,
      top: isNone(res.top) ? '' : res.top,
      bottom: isNone(res.bottom) ? '' : res.bottom,
      width: res.width,
      height: res.height
    };
  }) : [];
};
var normalize = {
  getBoundingClientRect: function getBoundingClientRect(api) {
    return function () {
      return api.apply(void 0, arguments).then(styleBoundingClientRectResponse);
    };
  }
};

var isNone = function isNone(val) {
  return typeof val === 'undefined' || !val && val !== 0;
};

var getBoundingClientRect$7 = normalize.getBoundingClientRect(function (selector) {
  return new Promise(function (resolve) {
    my.createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
      resolve(ret[0]);
    });
  });
});

var aliMiniAppModule = {
  getScrollOffset: getScrollOffset$6,
  getBoundingClientRect: getBoundingClientRect$7
};

var getScrollOffset$5 = function getScrollOffset(selector, context) {
  if (context === void 0) {
    context = wx;
  }

  return new Promise(function (resolve) {
    // const ele: any = document.querySelector(selector);
    // if (!ele || !ele._internal) {
    //   console.warn('element not found', selector);
    //   resolve([]);
    // }
    var createSelectorQuery = context.createSelectorQuery || wx.createSelectorQuery;
    createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
      resolve(ret[0] ? ret[0].map(function (i) {
        return {
          scrollLeft: i.scrollLeft,
          scrollTop: i.scrollTop
        };
      }) : []);
    });
  });
};

var getBoundingClientRect$6 = normalize.getBoundingClientRect(function (selector, context) {
  if (context === void 0) {
    context = wx;
  }

  return new Promise(function (resolve) {
    var createSelectorQuery = context.createSelectorQuery || wx.createSelectorQuery;
    createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
      resolve(ret[0]);
    });
  });
});

var weChatModule = {
  getScrollOffset: getScrollOffset$5,
  getBoundingClientRect: getBoundingClientRect$6
};

var getScrollOffset$4 = function getScrollOffset(selector, context) {
  if (context === void 0) {
    context = tt;
  }

  return new Promise(function (resolve) {
    context.createSelectorQuery = context.createSelectorQuery || tt.createSelectorQuery;
    context.createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
      resolve(ret[0] ? ret[0].map(function (i) {
        return {
          scrollLeft: i.scrollLeft,
          scrollTop: i.scrollTop
        };
      }) : []);
    });
  });
};

var getBoundingClientRect$5 = normalize.getBoundingClientRect(function (selector, context) {
  if (context === void 0) {
    context = tt;
  }

  return new Promise(function (resolve) {
    context.createSelectorQuery = context.createSelectorQuery || tt.createSelectorQuery;
    context.createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
      resolve(ret[0]);
    });
  });
});

var bytedanceModule = {
  getScrollOffset: getScrollOffset$4,
  getBoundingClientRect: getBoundingClientRect$5
};

var getScrollOffset$3 = function getScrollOffset(selector, context) {
  if (context === void 0) {
    context = ks;
  }

  return new Promise(function (resolve) {
    context.createSelectorQuery = context.createSelectorQuery || ks.createSelectorQuery;
    context.createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
      resolve(ret[0] ? ret[0].map(function (i) {
        return {
          scrollLeft: i.scrollLeft,
          scrollTop: i.scrollTop
        };
      }) : []);
    });
  });
};

var getBoundingClientRect$4 = normalize.getBoundingClientRect(function (selector, context) {
  if (context === void 0) {
    context = ks;
  }

  return new Promise(function (resolve) {
    context.createSelectorQuery = context.createSelectorQuery || ks.createSelectorQuery;
    context.createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
      resolve(ret[0]);
    });
  });
});

var kuaiShouModule = {
  getScrollOffset: getScrollOffset$3,
  getBoundingClientRect: getBoundingClientRect$4
};

var getScrollOffset$2 = function getScrollOffset(selector, context) {
  if (context === void 0) {
    context = swan;
  }

  return new Promise(function (resolve) {
    context.createSelectorQuery = context.createSelectorQuery || swan.createSelectorQuery;
    context.createSelectorQuery().selectAll(selector).scrollOffset().exec(function (ret) {
      resolve(ret[0] ? ret[0].map(function (i) {
        return {
          scrollLeft: i.scrollLeft,
          scrollTop: i.scrollTop
        };
      }) : []);
    });
  });
};

var getBoundingClientRect$3 = normalize.getBoundingClientRect(function (selector, context) {
  if (context === void 0) {
    context = swan;
  }

  return new Promise(function (resolve) {
    context.createSelectorQuery = context.createSelectorQuery || swan.createSelectorQuery;
    context.createSelectorQuery().selectAll(selector).boundingClientRect().exec(function (ret) {
      resolve(ret[0]);
    });
  });
});

var baiDuModule = {
  getScrollOffset: getScrollOffset$2,
  getBoundingClientRect: getBoundingClientRect$3
};

var getScrollOffset$1 = function getScrollOffset(selector) {
  return new Promise(function (resolve) {
    var el = document.querySelectorAll(selector);
    resolve(el.length === 0 ? [] : [].map.call(el, function (node) {
      return {
        scrollTop: node.scrollTop,
        scrollLeft: node.scrollLeft
      };
    }));
  });
};

var getBoundingClientRect$2 = normalize.getBoundingClientRect(function (selector) {
  return new Promise(function (resolve) {
    var el = document.querySelectorAll(selector);
    resolve(el.length === 0 ? [] : [].map.call(el, function (node) {
      return node.getBoundingClientRect();
    }));
  });
});

var webModule = {
  getScrollOffset: getScrollOffset$1,
  getBoundingClientRect: getBoundingClientRect$2
};

var getScrollOffset = function getScrollOffset(selector, context) {
  if (isWeb) {
    return webModule.getScrollOffset(selector);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.getScrollOffset(selector, context);
  } else if (isWeChatMiniProgram) {
    return weChatModule.getScrollOffset(selector, context);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.getScrollOffset(selector, context);
  } else if (isMiniApp) {
    return aliMiniAppModule.getScrollOffset(selector);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.getScrollOffset(selector, context);
  } else {
    throw new Error('Uni API：element暂不支持');
  }
};
var getBoundingClientRect$1 = function getBoundingClientRect(selector, context) {
  if (isWeb) {
    return webModule.getBoundingClientRect(selector);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.getBoundingClientRect(selector, context);
  } else if (isWeChatMiniProgram) {
    return weChatModule.getBoundingClientRect(selector, context);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.getBoundingClientRect(selector, context);
  } else if (isMiniApp) {
    return aliMiniAppModule.getBoundingClientRect(selector);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.getBoundingClientRect(selector, context);
  } else {
    throw new Error('Uni API：element暂不支持');
  }
};
var element = {
  getScrollOffset: getScrollOffset,
  getBoundingClientRect: getBoundingClientRect$1
};

var fn = function (_a) {
    var selector = _a.selector, success = _a.success, fail = _a.fail;
    element.getBoundingClientRect(selector).then(success).catch(fail);
};
var apiConfig = {
    web: fn,
    mini: fn,
};
var getBoundingClientRect = extend(apiConfig);

export { getBoundingClientRect };
